<template>
  <div>
    <div class="header-transparent">
      <app-header>
        <!--<p class="test-title">Тест «{{test.name}}»</p>-->
      </app-header>
    </div>

    <div class="content"
         v-if="!testFinished"
         :style="{ backgroundImage: `url('${bg}')` }">
      <!--style="background-image: url(https://pp.userapi.com/c824603/v824603001/dafcd/a5F-nXNtUaE.jpg);">-->

      <div id="tablet" :class="{closed: tabletIsClosed}">

        <div class="screen">

          <div class="status-bar" v-if="test">
            <app-timer @timeover="timeOver" ref="timer"/>
          </div>
          <!--ситуация-->

          <div class="cloud" v-show="!isQuestion">
            <div class="wrapper">
              <!--<h1>Ситуация №1</h1>-->
              <div class="head-question" v-if="question.maxScore !== maximumMax">
                Дополнительный вопрос
              </div>
              <div class="descr">
                {{question.situation}}
              </div>
              <div class="btn btn-lg" @click="isQuestion = true, case_question = false">Продолжить</div>
            </div>
          </div>

          <!--вопрос-->
          <transition name="slidefade">
            <div class="cloud" v-show="isQuestion">
              <div class="head-question" v-if="question.maxScore !== maximumMax && case_question === true">
                Дополнительный вопрос
              </div>
              <div class="descr" v-html="question.text">
              </div>
              <div class="grid answers">
                <transition name="slide">
                  <div class="row">
                    <div class="col-1 answer" v-for="(answer, index) in randomedList" :key="answer.id">
                      <div class="btn" @click="goToNextQuestion(answer)"
                      >
                        <span class="letter">{{String.fromCharCode(1040 + index)}}</span>
                        <span v-html="answer.text"></span>
                      </div>
                    </div>
                  </div>
                </transition>

                <!--меню-->
                <div v-if="switchOn === false" class="burger">
                 <span class="burger-icon" @click="switchOn = true">&#9776;</span>
                </div>
                <div v-else class="burger">
                  <span style="margin-left: 2px" @click="switchOn = false" class="burger-icon">&#10006;</span>
                </div>
                <div v-show="switchOn" class="flex-between animated fadeInUp">
                  <div class="back" @click="goToSituation" v-show="question.situation.length">
                    <img src="@/assets/img/arrow.png" alt="">
                    <span>назад</span>
                  </div>
                  <div class="finish-test">
                    <!--<router-link :to="{ name: 'FinishGame' }">-->
                      <!--<div class="finish"><img src="@/assets/img/turnoff.png" alt="">-->
                        <!--<span>Завершить тест</span>-->
                      <!--</div>-->
                    <!--</router-link>-->
                    <div class="finish" @click="finishTest"><img src="@/assets/img/turnoff.png" alt="">
                      <span>Завершить тест</span>
                    </div>
                  </div>
                  <div class="help" @click="goToHelp"><img src="@/assets/img/book.png" alt=""> <span>библиотека</span></div>
                </div>

              </div>
            </div>
          </transition>

          <!--<transition name="slidefade">
            <div class="cloud" v-if="isHelp">
            </div>-->

        </div>

<!--        <div class="arrow" :class="{top: tabletIsClosed}" @click="toggleTablet()"></div>-->
      </div>
    </div>

    <test-finish v-if="testFinished" :minutes="minutes" :percent="percentQ()" :positive="positiveFinish" :score="score" :timeend="timeEnd"></test-finish>
  </div>
</template>

<script>
  import Timer from '@/components/timer/Timer'
  import TestFinish from '@/pages/game/TestFinish'
  import TestsService from '@/services/TestsService'
  import BadAnswer from '@/components/modal/BadAnswer'
  import _ from 'lodash'

  let minutes
  let seconds
  let allTime

  export default {
    name: 'test',
    props: ['questions'],
    data () {
      return {
        tabletIsClosed: true,
        audioVzmah: new Audio(require('@/assets/music/vzmah.mp3')),
        test: {},
        test_questions: [],
        questionsCount: this.questions,
        question: {},
        isQuestion: false,
        isHelp: false,
        criticalCount: 0,
        questionCount: 1,
        score: 0,
        scoreCount: 0,
        maxScorePoints: 0,
        percent: 0,
        percents: 0,
        testFinished: false,
        positiveFinish: true,
        backgroundImage: '',
        switchOn: false,
        randomedList: [],
        minutes: 0,
        maximumMax: 0,
        startTime: new Date(),
        maxCount: 0,
        badAnswer: false,
        case_question: true,
        seconds: 0,
        timeEnd: false,
        loading: false
      }
    },
    methods: {
      goToNextQuestion (answer) {
        if (this.loading) {
          return
        }
        this.loading = true
        if (window.innerWidth > 700) {
          this.tabletIsClosed = true
        }

        // this.case_question = true

        if (answer.is_critical) {
          this.criticalCount++
          this.badAnswer = true
          const vm = this
          setTimeout(function () {
            vm.badAnswer = false
          }, 3000)
        }

        let vm = this

        setTimeout(function () {
          vm.case_question = true
        }, 1000)

        if (this.question.maxScore === this.maximumMax) {
          this.maxScorePoints++
        }

        this.score += answer.score

        if (answer.success === true || answer.success === false) { // пройден или не пройден
          this.finishTest(answer)
        } else { // продолжаем тест
          let question = this.$store.getters.questionById(answer.next_question, this.test.id)
          this.backgroundImage = question.image
          if (this.tabletIsClosed) {
            setTimeout(() => {
              this.loading = false
              this.questionCount++

              this.question = question

              this.isQuestion = this.question.situation.length === 0
              this.tabletIsClosed = false
              this.audioVzmah.play()

              this.randomedList = this.randomList(this.question.question_answers)
            }, 1500)
          } else {
            this.loading = false
            this.questionCount++

            this.question = question

            this.isQuestion = this.question.situation.length === 0
            this.tabletIsClosed = false
            this.audioVzmah.play()

            this.randomedList = this.randomList(this.question.question_answers)
          }
        }
      },
      addPoints (points) {
        for (let i in points) {
          const pointIndex = this.points.findIndex(
            x => x.name === points[i].name)
          this.points[pointIndex].value += parseFloat(points[i].value)
        }
      },
      finishTest (answer) {
        let orgSlug = this.$route.params.slug
        this.$refs.timer.clearTimer()
        TestsService.postEndTest(orgSlug, this.$store.getters.getPlayer.id, this.test.id, {
          critical_count: this.criticalCount,
          success: answer.success,
          question_count: this.questionCount,
          score: this.score,
          time: this.seconds,
          // time: this.$store.getters.timePass,
          points: answer.points,
          percent: this.percentQ(),
          minute: this.minutes
        }).then(
          () => {
            this.positiveFinish = answer.success
            this.testFinished = true
            clearTimeout(minutes)
            clearTimeout(seconds)
            clearTimeout(allTime)
          }
        )
      },

      toggleTablet () {
        if (this.tabletIsClosed) {
          this.audioVzmah.play()
        }
        this.tabletIsClosed = !this.tabletIsClosed
      },
      randomList (array) {
        if (array) {
          return array.map((a) => [Math.random(), a]).sort((a, b) => a[0] - b[0]).map((a) => a[1])
        }
        return undefined
      },
      goToHelp () {
        let routeData = this.$router.resolve({name: 'TestHelp', params: {id: 1, slug: process.env.ORG_SLUG}})
        window.open(routeData.href, '_blank')
      },
      goToSituation () {
        this.isQuestion = false
      },
      timerFunction () {
        minutes = setInterval(() => {
          this.minutes = Math.floor((new Date().getTime() - this.startTime.getTime()) / 60000)
        }, 60000)
        seconds = setInterval(() => {
          this.seconds = Math.floor((new Date().getTime() - this.startTime.getTime()) / 1000)
        }, 1000)
      },
      percentQ () {
        this.percents = Math.round(this.maxScorePoints * 100 / this.maxCount)
        if (this.percents > 100 || this.percents > 98) {
          return 100
        }
        return this.percents
      },
      // fullPercent () {
      //   const first = _.maxBy(this.scoreCount, 'score')
      //   this.maxScore = _.filter.this.questionsCount(first)
      // }
      timeOver () {
        this.timeEnd = true
        this.finishTest(false)
      }
    },
    computed: {
      testPoints () {
        return this.$store.getters.test.points
      },
      bg () {
        return require('@/assets/img/background_new2.png')
      }
    },
    mounted () {
      this.test = this.$store.getters.test
      this.question = this.$store.getters.questionById(this.test.start_question, this.test.id)
      this.isQuestion = this.question.situation.length === 0
      this.backgroundImage = this.question.image

      this.scoreCount = _.maxBy(this.question.question_answers, 'score')
      // this.maxScore = _.filter(this.questionsCount, function (item) {
      //   let max = _.maxBy(item.question_answers, 'score')
      //   return max ===
      // })
      // this.maxPoints = _.maxBy(this.questionsCount, 'score')

      this.questionsCount.forEach(function (item) {
        item.maxScore = 0
        if (item.question_answers.length > 0) {
          item.maxScore = (_.maxBy(item.question_answers, 'score')).score
        }
      })

      this.maximumMax = (_.maxBy(this.questionsCount, 'maxScore')).maxScore

      this.maxCount = (_.filter(this.questionsCount, ['maxScore', this.maximumMax])).length

      this.randomedList = this.randomList(this.question.question_answers)

      this.timerFunction()

      this.points = [] // копирование компетенций
      for (let i in this.testPoints) {
        this.points.push({name: this.testPoints[i].name, value: 0})
      }
      this.audioVzmah.volume = 0.1

      setTimeout(() => {
        this.tabletIsClosed = false
        this.audioVzmah.play()
      }, 100)

      allTime = setTimeout(() => {
        this.timeOver()
      }, 10800000)
    },
    components: {
      'app-timer':
      Timer,
      'test-finish':
      TestFinish,
      'bad-answer':
      BadAnswer
    }

  }
</script>

<style scoped lang="scss">
  .head-question {
   text-align: center;
    margin-top: -20px;
    padding-bottom: 10px;
  }
  .flex-between {
    /*background-color: rgba(0, 0, 0, 0.6);*/
    height: 10%;
    position: absolute;
    bottom: 45px;
    width: 90%;
    z-index: 1;
    user-select: none;
    justify-content: right;

    .burger {
      position: absolute;
      right: 10px;
      top: 0;
      user-select: none;
    }

    .back {
      margin-top: 25px;
    }

    .help {
      margin-top: 30px;
    }
  }

  /*.finish-test {*/

    /*.btn {*/
      /*margin-top: 10%;*/
    /*}*/
  /*}*/

  .burger {
    position: absolute;
    right: 15px;
    bottom: 48px;
    cursor: pointer;
    background-color: #437683;
    display: inline-block;
    height: 40px;
    width: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-radius: 40px;
    box-sizing: border-box;
    color: #fff;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    font-weight: 300;
    white-space: nowrap;
    z-index: 1000;

    .burger-icon {
      margin-left: 1.5px;
      font-size: 20px;
      user-select: none;
    }
  }

  .help, .finish, .back {
    float: right;
    /*margin-top: 20px;*/
    background-color: #437683;
    display: inline-block;
    height: 35px;
    line-height: 35px;
    padding: 0 8px;
    border-radius: 35px;
    box-sizing: border-box;
    width: 134px;
    overflow: hidden;
    transition: all 0.1s ease-out;
    cursor: pointer;
    color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    font-weight: 300;
    white-space: nowrap;
    margin-right: 15px;
    img {
      width: 19px;
      margin-right: 5px;
      position: relative;
      top: -1px;
      margin-left: 2px;
    }
    span, img {
      display: inline-block;
      vertical-align: middle;
    }
  }

  .finish {
    width: 164px;
    margin-top: 28px;

    img {
      width: 15px;
    }
  }

  .back {
    width: 100px;
    color: #fff;

    &:hover {
      color: #fff;
    }

  }

  .screen {
    box-sizing: border-box;
    height: 90%;
    width: 731px;
    position: relative;
    left: 3px;
    top: 87px;
    margin: 0 auto;
  }

  #tablet {
    position: absolute;
    bottom: 0;
    margin: 0 auto;
    height: 782px;
    width: 100%;
    min-width: 1376px;
    max-width: 100%;
    //background: url('/static/tablet550.png') center 0 no-repeat;
    //background-size: contain;
    transition: bottom 0.3s ease-in-out;
    &.closed {
      bottom: -90%;
    }
    .arrow {
      position: fixed;
      bottom: 30px;
      transition: all 0.15s linear;
      width: 20px;
      height: 20px;
      border: 5px solid #437683;
      border-top: none;
      border-left: none;
      left: calc(50% - 10px);
      transform: rotate(45deg);
      cursor: pointer;
      &:hover {
        bottom: 25px;
      }
      &.top {
        transform: rotate(-135deg);
        &:hover {
          bottom: 35px;
        }
      }
    }
  }

  .status-bar {
    background-color: rgba(255, 255, 255, 0.95);
    color: #000;
    padding: 30px 30px 5px;
    border-radius: 45px 45px 0 0;
  }

  .content {
    height: 100vh;
    max-height: 100vh;
    max-width: 100%;
    width: 100%;
    min-width: 100%;
    overflow: hidden;
    position: relative;
    //background-position: center center;
    background-size: cover;
    transition: background-image .5s ease-out;
    box-sizing: border-box;
    /*min-width: 1200px;*/
  }

  .cloud {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 30px 18px;
    overflow: auto;
    box-sizing: border-box;
    height: 92%;
    .wrapper {
      //height: calc(100% - 50px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    h1 {
      text-align: center;
      font-size: 24px;
      margin: 0;
      margin-bottom: 20px;
    }
    .descr {
      font-size: 1.5em;
      text-align: center;
      font-weight: 400;
      margin-bottom: 30px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      background-color: #F5F5F5;
    }

    &::-webkit-scrollbar {
      width: 7px;
      background-color: #F5F5F5;
      padding: 0 3px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
      background-color: #437683;
    }
  }

  .test-title {
    text-align: center;
    margin: 0;
  }

  .btn-lg {
    background-color: #BBDEF0;
    display: block;
    margin: 0 auto;
    font-size: 18px;
    text-align: center;
    width: 400px;
    max-width: 100%;
  }

  .answers {
    .answer {
      margin: 10px 50px;
      padding: 0 10px;
      .btn {
        background-color: rgba(255, 255, 255, 0.9);
        box-shadow: none;
        padding: 20px 10px;
        /*height: 100px;*/
        height: 100px;
        max-height: 130px;
        font-size: 16px;
        font-weight: 400;
        display: flex;
        align-items: center;
        border-radius: 5px;
        &.textSm {
          font-size: 14px;
        }
        &.textXs {
          font-size: 14px;
          height: auto;
          max-height: 100%;
          padding: 10px;
        }
        &:hover {
          background-color: #d3dee1;
        }

      }
      .letter {
        //color: #fff;
        font-size: 24px;
        margin-right: 10px;
        font-weight: 500;
      }
    }
  }

  .top {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    > * {
      display: inline-block;
      vertical-align: middle;
    }
    > span {
      margin-right: 20px;
      margin-left: 10px;
    }
  }

  @media screen and (max-width: 1200px) {
    #tablet {
      left: 50%;
      margin-left: -600px;
    }
  }

  @media screen and (max-width: 700px) {
    .content {
      max-height: none;
      padding-top: 100px;
      transition: none;
    }
    #tablet {
      margin: 0;
      background: transparent;
      max-width: 100%;
      width: 100%;
      min-width: 100%;
      box-sizing: border-box;
      position: relative;
      left: 0;

      .screen {
        max-width: 100%;
        width: 100%;
        min-width: 100%;
        position: static;
        height: 100%;
        /*max-height: 60vh;*/
      }
      .arrow {
        position: absolute;
      }
      .status-bar {
        box-sizing: border-box;
        width: 100%;
      }
      .cloud {
        max-width: 100%;
        box-sizing: border-box;
        overflow: auto;
        font-size: 12px;
        font-weight: 400;
        .descr {
          font-weight: 400;
        }
        .wrapper {
          height: 100%;
        }
      }
    }
    .answers {
      .answer {
        .btn {
          font-size: 14px;
          height: auto;
          padding: 10px;
          font-weight: 400;
        }
      }
    }
  }

  /*animated */
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  @-webkit-keyframes fadeInUp {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUp {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
  }

</style>



// WEBPACK FOOTER //
// src/pages/game/Test.vue